
import React from "react";
import * as Material from "@mui/material";
import { ArrowDropDownRounded, CloseRounded } from "@mui/icons-material";
import { Button } from "@fragments";

export default function Filter({ name, valueLabel, onClick, icon, customComponent, className, onClear }) {
    return (
        <div className={`filter-item pressable ${className}`} onClick={(e) => {
            if (!customComponent) {
                onClick(e);
            }
        }}>
            {icon && <span className="filter-icon">{icon}</span>}
            <span>{name}</span>
            <Material.Divider orientation="vertical" flexItem />
            {
                customComponent ? customComponent : <span className="bold">{valueLabel}</span>
            }
            {onClear ? (
                <Button
                    icon={<CloseRounded style={{ fontSize: 14 }} />}
                    color="overlay"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClear();
                    }}
                />
            ) : (
                <ArrowDropDownRounded />
            )}
        </div>
    )
}
